import React from "react";
import {Spinner} from "react-bootstrap";

const FullScreenSpinner = () => (
  <div
    style={{
      position: "fixed",
      inset: 0,
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      background: "#000 !important",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1301,
      color: "#fff",
    }}
  >
    Загрузка ...
    <Spinner animation="border" />
  </div>
);

export default FullScreenSpinner;
